$(document).ready(function(){
  $('.block__collection-main-content').each(function(){
    var current_collection = $(this).attr('id');
    var  columnvalue = $('#'+current_collection+' .block__card-product--slider').data('column');
     var  mobilecolumnvalue = $('#'+current_collection+' .block__card-product--slider').data('column-mobile');
    $('#'+current_collection+' .block__section_product-card_man').not('.slick-initialized').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: columnvalue,
      slidesToScroll: 1,
      prevArrow: '<button role="button" aria-label="prev-btn" class="block__section-slick-arrow-coll-main left" aria-label="prev-btn"><span  class="slick-arrow-collection prev-arrow" aria-label="Previous Slide"><svg width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" fill="#0F0F0F"></path><path d="M15.3927 17.3749L18.7452 14.0224L17.8614 13.1385L13 17.9999L17.8614 22.8612L18.7452 21.9774L15.3927 18.6249H23V17.3749H15.3927Z" fill="white"></path></svg></span></button>',
      nextArrow: '<button role="button" aria-label="next-btn" class="block__section-slick-arrow-coll-main right" aria-label="next-btn"><span  class="slick-arrow-collection next-arrow" aria-label="Next Slide"><svg width="36" height="36" viewBox="0 0 36 36" fill="none"><path d="M18 33C9.71572 33 3 26.2843 3 18C3 9.71573 9.71572 3 18 3C26.2843 3 33 9.71573 33 18C33 26.2843 26.2843 33 18 33Z" fill="#0F0F0F"/><path d="M20.6073 17.3749L17.2548 14.0224L18.1386 13.1385L23 17.9999L18.1386 22.8612L17.2548 21.9774L20.6073 18.6249H13V17.3749H20.6073Z" fill="white"/></svg></span></button>',
      responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 800,
        settings: "unslick"
      }
    ]
    });  
    $(".prev-btn").click(function (event) {
         event.preventDefault();
		$('#'+current_collection+' .block__section_product-card_man').slick("slickPrev");
	});
	$(".next-btn").click(function (event) {
    event.preventDefault();
		$('#'+current_collection+' .block__section_product-card_man').slick("slickNext");
	});
	$(".prev-btn").addClass("slick-disabled");
	$('#'+current_collection+' .block__section_product-card_man').on("afterChange", function (event) {
       event.preventDefault();
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn").addClass("slick-disabled");
		} else {
			$(".prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn").addClass("slick-disabled");
		} else {
			$(".next-btn").removeClass("slick-disabled");
		}
	});
  });
}); 
 



